import { render, staticRenderFns } from "./landing.component.html?vue&type=template&id=30365a3f&scoped=true&"
import script from "./landing.component.js?vue&type=script&lang=js&"
export * from "./landing.component.js?vue&type=script&lang=js&"
import style0 from "./landing.component.css?vue&type=style&index=0&id=30365a3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30365a3f",
  null
  
)

export default component.exports